var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"router-wrapper"},[(_vm.mainScreen)?[(_vm.selectedApp)?_c('TabsView'):_c('AppListView')]:[_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }